import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FolderZipIcon(props: IconProps) {
    return <Icon {...props} iconKey={"folder_zip"}/>
}
